<smart-cart-timer-config
  [formGroup]="formGroup.controls.timer"
  [placementOptions]="placementOptions"
  enableSubtitle="Add urgency with a countdown in your goal messages"
  durationHint="Timer starts when customer opens the smart cart."
  [smartCartId]="smartCartId"
  [usageToken]="usageToken"
  [previewedState]="previewTimerState()"
  (previewStateChange)="previewTimer($event)"></smart-cart-timer-config>

<smart-cart-goals-custom-code-card
  [enabledControl]="formGroup.controls.customCode.controls.enabled"
  [codeControl]="formGroup.controls.customCode.controls.code"></smart-cart-goals-custom-code-card>
